import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { invalidateTimeEntries } from './keys';
import { ITimeEntry } from './types';

interface ISaveTimeEntryHoursVariables {
	day: string;
	hours: number;
}

export const useSaveTimeEntryHoursMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: unknown) => void;
	onSuccess?: (data: ITimeEntry) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ day, hours }: ISaveTimeEntryHoursVariables) =>
			userSession.webServiceHelper.callAsync<ITimeEntry>(`TimeEntry/days/${encodeURIComponent(day)}`, 'PUT', { hours }),
		onError,
		onSuccess,
		onSettled: () => invalidateTimeEntries(),
	});
};
